import { BaseImageSettings } from '../../shared/hooks/useImageSettings';

export const WISHLIST_MODULE_NAME = 'cus-wishlist';

export const WISHLIST_IMAGE_VIEWPORT_SETTINGS: BaseImageSettings = {
    xs: 'large',
    sm: 'small',
    md: 'small',
    lg: 'small',
    xl: 'small'
};
